import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  TemplateRef
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'moxi-confirmation-button',
  imports: [
    TranslatePipe,

    // Ant Design
    NzButtonModule,
    NzIconModule,
    NzTooltipModule,
    NzPopconfirmModule
  ],
  templateUrl: './confirmation-button.component.html',
  styleUrl: './confirmation-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationButtonComponent {
  private isLastActionTrusted = false;

  text = input<string | undefined>();
  type = input<'primary' | 'dashed' | 'link' | 'text' | 'default'>('primary');
  danger = input(false);
  shape = input<'circle' | 'round' | undefined>();
  tooltip = input<string | undefined>();
  confirmText = input<string | TemplateRef<void> | undefined>();
  icon = input<string | undefined>();
  size = input<'small' | 'large' | 'default'>('default');
  loading = input(false);
  disabled = input(false);
  popconfirmPlacement = input<
    | 'top'
    | 'topLeft'
    | 'topRight'
    | 'bottom'
    | 'bottomLeft'
    | 'bottomRight'
    | 'left'
    | 'leftTop'
    | 'leftBottom'
    | 'right'
    | 'rightTop'
    | 'rightBottom'
    | undefined
  >(undefined);

  iconColor = computed(() =>
    this.danger() ? this.dangerColor : this.warningColor
  );

  className = computed(() => (this.danger() ? 'ant-popover--alert' : null));

  dangerColor = '#cf1322';
  warningColor = '#1a74a8';

  confirm = output<boolean>();

  checkIfClickIsTrusted(event: MouseEvent): void {
    // Check if the click event is trusted
    this.isLastActionTrusted = event.isTrusted;
  }

  onConfirm(): void {
    // Prevent untrusted events (e.g. from external scripts) from triggering the update
    if (this.isLastActionTrusted) {
      this.confirm.emit(true);
    }

    this.isLastActionTrusted = false;
  }
}
